import { render, staticRenderFns } from "./milestone.vue?vue&type=template&id=267054ef&scoped=true&"
import script from "./milestone.vue?vue&type=script&lang=js&"
export * from "./milestone.vue?vue&type=script&lang=js&"
import style0 from "./milestone.vue?vue&type=style&index=0&id=267054ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267054ef",
  null
  
)

export default component.exports